"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Handle =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Handle, _React$Component);

  function Handle() {
    _classCallCheck(this, Handle);

    return _possibleConstructorReturn(this, _getPrototypeOf(Handle).apply(this, arguments));
  }

  _createClass(Handle, [{
    key: "renderHandle",
    value: function renderHandle() {
      return _react.default.createElement("div", _extends({
        className: "".concat(_ThemeManager.default.getVar('classPrefix'), "-slider-handle"),
        style: {
          left: "".concat(this.props.offset, "%")
        }
      }, this.props.handleProps));
    }
  }, {
    key: "renderWithTooltip",
    value: function renderWithTooltip() {
      return _react.default.createElement(_Tooltip.default, {
        action: "hover",
        content: this.props.value,
        size: "mini"
      }, this.renderHandle());
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.tooltip) {
        return this.renderWithTooltip();
      }

      return this.renderHandle();
    }
  }]);

  return Handle;
}(_react.default.Component);

exports.default = Handle;
Handle.defaultProps = {
  offset: 0,
  value: 0,
  tooltip: false
};
Handle.propTypes = {
  /**
   * Handle offset from the starting of Slider
   */
  offset: _propTypes.default.number,

  /**
   * Tooltip value to be shown on Handle
   */
  value: _propTypes.default.number,

  /**
   * Slider with tooltip
   */
  tooltip: _propTypes.default.bool,

  /**
   * Props to pass to Handle component
   */
  handleProps: _propTypes.default.object
};